module.exports = __webpack_public_path__ + "static/media/file.dadbecc4.webp";